export type PaletteKey = "primary" | "secondary" | "error" | "info" | "success" | "warning";

export const STATUS_MAP = {
    N: { labelId: "document-status-n", fallback: "_Nowy", color: "info" },
    I: { labelId: "document-status-i", fallback: "_Do zatwierdzenia", color: "info" },
    K: { labelId: "document-status-k", fallback: "_Korekta", color: "warning" },
    A: { labelId: "document-status-a", fallback: "_Zatwierdzony", color: "success" },
    F: { labelId: "document-status-f", fallback: "_Zakończony", color: "success" },
    P: { labelId: "document-status-p", fallback: "_Opublikowany", color: "secondary" },
    O: { labelId: "document-status-o", fallback: "_Opiniowanie", color: "info" },
    D: { labelId: "document-status-d", fallback: "_Zaopiniowany", color: "info" },
    E: { labelId: "document-status-e", fallback: "_Zaimportowany", color: "info" },
    R: { labelId: "document-status-r", fallback: "_Odrzucony", color: "error" },
    X: { labelId: "document-status-x", fallback: "_importowanie", color: "warning" },
    B: { labelId: "document-status-b", fallback: "_ready to publish", color: "secondary" },
    H: { labelId: "document-status-h", fallback: "_ready to publish", color: "secondary" },
    C: { labelId: "document-status-c", fallback: "_cancelled", color: "error" },
    W: { labelId: "document-status-w", fallback: "_approved_with_warning", color: "error" },
} as const;

export function getStatusEntry(status: string | null | undefined) {
    const key = (status ?? "").toString().trim().toUpperCase();
    return STATUS_MAP[key as keyof typeof STATUS_MAP] ?? {
        labelId: "document-status-unknown",
        fallback: key || "UNKNOWN",
        color: "info" as PaletteKey,
    };
}